import dayjs from 'dayjs';
import { IWorkOrder } from 'app/shared/model/work-order.model';
import { IEmployee } from 'app/shared/model/employee.model';
import { TaskStatus } from 'app/shared/model/enumerations/task-status.model';

export interface ITask {
  id?: number;
  name?: string | null;
  description?: string | null;
  startDate?: dayjs.Dayjs | null;
  endDate?: dayjs.Dayjs | null;
  taskStatus?: keyof typeof TaskStatus | null;
  createdTimestamp?: dayjs.Dayjs | null;
  workOrder?: IWorkOrder | null;
  owner?: IEmployee | null;
}

export const defaultValue: Readonly<ITask> = {};
